<template>
<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<g>
	<g>
		<g>
			<path d="M387.298,0H55.968v512h400.064V68.734L387.298,0z M392.069,27.798l36.165,36.165h-36.165V27.798z M439.748,495.716
				H72.252V16.284h303.532v63.963h63.964V495.716z"/>
			<path d="M103.94,288.128H408.06V127.927H103.94V288.128z M391.779,271.844H120.225v-39.357
				c10.95,0.936,17.343,3.773,24.532,6.967c9.172,4.076,19.568,8.697,39.286,8.697s30.113-4.62,39.286-8.697
				c8.805-3.914,16.41-7.294,32.673-7.294c16.263,0,23.867,3.38,32.674,7.294c9.172,4.076,19.568,8.697,39.286,8.697
				c19.717,0,30.113-4.62,39.286-8.697c7.188-3.195,13.581-6.032,24.531-6.967V271.844z M120.222,144.212h271.552v71.961
				c-14.602,1.068-23.328,4.927-31.144,8.401c-8.805,3.914-16.41,7.294-32.673,7.294c-16.261,0-23.866-3.38-32.673-7.293
				c-9.172-4.077-19.568-8.698-39.286-8.698c-19.717,0-30.113,4.62-39.286,8.697c-8.805,3.914-16.41,7.294-32.673,7.294
				s-23.866-3.38-32.673-7.293c-7.816-3.474-16.542-7.332-31.144-8.401V144.212z"/>
			<path d="M168.197,39.977H103.94v64.257h64.257V39.977z M151.913,87.95h-31.688V56.261h31.688V87.95z"/>
			<rect x="184.045" y="47.973" width="87.946" height="16.284"/>
			<rect x="184.045" y="79.956" width="47.973" height="16.284"/>
			<path d="M335.953,216.17c17.715,0,32.129-14.413,32.129-32.129c0-17.716-14.413-32.129-32.129-32.129
				c-17.715,0-32.128,14.413-32.128,32.129C303.825,201.758,318.238,216.17,335.953,216.17z M335.953,168.197
				c8.737,0,15.845,7.108,15.845,15.845c0,8.736-7.108,15.845-15.845,15.845c-8.736,0-15.844-7.107-15.844-15.845
				C320.111,175.304,327.218,168.197,335.953,168.197z"/>
			<rect x="136.071" y="159.911" width="15.99" height="16.284"/>
			<rect x="168.054" y="159.911" width="15.99" height="16.284"/>
			<rect x="200.036" y="159.911" width="15.99" height="16.284"/>
			<rect x="144.061" y="319.812" width="263.848" height="16.284"/>
			<rect x="104.089" y="359.795" width="303.821" height="16.284"/>
			<rect x="104.089" y="399.768" width="303.821" height="16.284"/>
			<rect x="104.089" y="439.751" width="239.856" height="16.284"/>
			<rect x="359.936" y="439.751" width="15.99" height="16.284"/>
			<rect x="391.919" y="439.751" width="15.99" height="16.284"/>
		</g>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
</template>
